import React, {useState, useContext, useEffect} from "../../_snowpack/pkg/react.js";
import {Switch} from "../../_snowpack/pkg/@headlessui/react.js";
import {SettingsContext, NotificationContext} from "../App.js";
import {useDidMount} from "../hooks/util.js";
const SettingSwitch = ({label, setting, value}) => {
  const [settings, setSettings] = useContext(SettingsContext);
  const [, setNotification] = useContext(NotificationContext);
  const [enabled, setEnabled] = useState(value);
  const didMount = useDidMount();
  useEffect(() => {
    if (didMount) {
      setSettings({...settings, [setting]: enabled});
      setNotification({
        message: `${label} ${enabled ? "enabled" : "disabled"}`,
        type: "success"
      });
    }
  }, [enabled]);
  return /* @__PURE__ */ React.createElement(Switch.Group, null, /* @__PURE__ */ React.createElement("div", {
    className: "flex justify-between"
  }, /* @__PURE__ */ React.createElement(Switch.Label, null, label), /* @__PURE__ */ React.createElement(Switch, {
    checked: enabled,
    onChange: setEnabled,
    className: `${enabled ? "bg-red-600 dark:bg-gray-900" : "bg-gray-200 dark:bg-gray-700"} relative inline-flex items-center h-6 rounded-full w-11`
  }, /* @__PURE__ */ React.createElement("span", {
    className: "sr-only"
  }, "Enable notifications"), /* @__PURE__ */ React.createElement("span", {
    className: `${enabled ? "translate-x-6" : "translate-x-1"} inline-block w-4 h-4 transform bg-white rounded-full transition ease-in-out`
  }))));
};
export default SettingSwitch;
